module.exports = __webpack_public_path__ + "assets/img/cases-2.b2fc683d.png";